import { render } from "./TimeStamp.vue?vue&type=template&id=6f66b6c2&scoped=true"
import script from "./TimeStamp.vue?vue&type=script&lang=js"
export * from "./TimeStamp.vue?vue&type=script&lang=js"

import "./TimeStamp.vue?vue&type=style&index=0&id=6f66b6c2&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/webtool/www-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f66b6c2"]])

export default __exports__